import React, { useState } from 'react';
import { Spin } from 'antd';

import { RequestPasswordResetForm } from '../../components/user_management/request-password-reset-form';

const ForgetPasswordView = function (props) {
	const [loading, setLoading] = useState(false);
	const [submitted, setSubmitted] = useState(false);

	return (
		<div className="bg-overlay-dark">
			<div className="mx-auto form-container justify-content-center d-flex flex-column align-items-center py-3">
				<div className="m-4 text-center">
					<p
						style={{
							color: '#ffffff',
							fontSize: '2.625rem',
							fontWeight: 400,
							margin: '10px 0'
						}}
					>
						Reset Your Password
					</p>
				</div>
				<div className="p-4 mt-0 my-md-5 ta-form-container">
					{submitted ? (
						<div
							style={{
								color: '#4df2c6',
								padding: '5px'
							}}
						>
							We are sending instructions to reset your password. If you do not receive an email, check
							your spam folder or make sure this email address is registered with Talents Arena. For help,
							contact our <a href="mailto:support@talentsarena.net">support</a>.
						</div>
					) : (
						<Spin tip="please wait..." spinning={loading}>
							<RequestPasswordResetForm
								onSuccess={() => {
									setLoading(false);
									setSubmitted(true);
								}}
								onError={() => setLoading(false)}
								onSubmit={() => setLoading(true)}
							/>
						</Spin>
					)}
				</div>
			</div>
		</div>
	);
};

export default ForgetPasswordView;
